import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the TeacherCommunicationDetailMobile state domain
 */

const selectTeacherCommunicationDetailMobileDomain = state =>
  state.TeacherCommunicationDetailMobile || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate.detailID,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate.firstRender,
  );

const makeSelectItemDetail = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate.itemDetail,
  );

const makeSelectUpdateLoading = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate.updateLoading,
  );


/**
 * Default selector used by Communication
 */

const makeSelectTeacherCommunicationDetailMobile = () =>
  createSelector(
    selectTeacherCommunicationDetailMobileDomain,
    substate => substate,
  );

export default makeSelectTeacherCommunicationDetailMobile;
export {
  selectTeacherCommunicationDetailMobileDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemDetail,
  makeSelectUpdateLoading,
};
